// API build/deploy info query. Public (no auth) — mirrors the server resolver
// (api/src/graphql/query/versionInfoQuery.js). Rendered in the footer alongside
// the UI's own build info. `deployedAt` is an ISO datetime.
export default () => `
	versionInfo {
		version
		deployedAt
	}
`;
